<script>
export default {
  name: 'ReviewCard',

  props: {
    review: {
      type: Object,
      required: true
    }
  },

  computed: {
    created () {
      return this.$dateFns.format(this.review.created_at, 'dd.MM.yyyy')
    }
  }
}
</script>

<template>
  <div :class="$style.card">
    <div :class="$style.top">
      <img :class="$style.avatar" :src="review.avatar" :alt="review.full_name" />

      <div :class="$style.header">
        <div :class="$style.headerRow">
          <span :class="$style.name">{{ review.full_name }}</span>
          <Currency type="money" real size="16">
            <span :class="$style.total">{{ (review.total / 100).toFixed(2) }}</span>
          </Currency>
        </div>
        <div :class="$style.headerRow">
          <span :class="$style.date">{{ created }}</span>
          <div :class="$style.stars">
            <img v-for="i in review.rating" :key="`star_${i}`" :class="$style.star" :src="require('~/assets/img/icons/star-gold.svg')" alt="star" />
            <img v-for="i in (5 - review.rating)" :key="`no_star_${i}`" :class="$style.star" :src="require('~/assets/img/icons/star-grey.svg')" alt="star empty" />
          </div>
        </div>
      </div>
    </div>
    <div :class="$style.bottom">
      <p :class="$style.title">
        {{ review.title }}
      </p>
      <p :class="$style.description">
        {{ review.description }}
      </p>
    </div>
  </div>
</template>

<style lang="scss" module>
.card {
  width: 100%;
  border-radius: 8px;
  background: $blue-grey60;
  overflow: hidden;
}

.top {
  display: grid;
  grid-template-columns: 48px 1fr;
  grid-gap: 8px;
  align-items: center;
  padding: 12px;
  background: $blue-grey50;
}

.bottom {
  padding: 12px;
}

.avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
}

.header {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 4px;

  &Row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.name {
  color: $white;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

.date {
  color: $white;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
}

.total {
  color: $white;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

.stars {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.star {
  width: 16px;
  height: 16px;
}

.title {
  margin: 0 0 8px;
  color: $white;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
}

.description {
  margin: 0;
  color: $blue-grey05;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}
</style>
